import config from 'react-global-configuration';
import { FormikValues } from '../components/SearchAllContent/types';

function listIDs(values: FormikValues) {
  const IDs = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(values)) {
    if (IDs.length > 99) {
      break;
    }

    if (key.match(/[0-9]/g) && value === true) {
      IDs.push(key);
    }
  }

  return IDs;
}

export async function mailOcularImages(values: FormikValues) {
  const API_URL = config.get('API_URL');

  const idsToExport = listIDs(values);

  const response = await fetch(`${API_URL}/api/ocular_export_mailing?_format=json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ids: idsToExport,
      email: values.email,
    }),
  });

  const data = await response.json();

  return {
    status: response.status,
    data,
  };
}

export function createMetadataEmail(values: FormikValues) {
  const idsForRequest = listIDs(values);
  window.location.href = `mailto:oculardatabase@gmail.com?subject=Request%20for%20Ocular%20Database%20Photos%20Metadata&body=Hello%2C%20I%20would%20like%20to%20request%20the%20metadata%20for%20the%20following%20Ocular%20IDs%3A%0D%0A%0D%0A${idsForRequest.join('%0D%0A')}%0D%0A%0D%0AI%20understand%20that%20this%20information%20can%20support%20training%2Fresearch%2Fmapping%2Ftool%20development%20etc.%20My%20purpose%20for%20requesting%20this%20information%20is%20_______%20(up%20to%2050%20words).%0D%0AI%20understand%20that%20I%20can%20only%20use%20metadata%20of%20photos%20indicating%20patient%20consent%20and%20that%20the%20metadata%20as%20provided%20by%20the%20contributor%20may%20or%20may%20not%20be%20complete.%0D%0AThank%20you.%0D%0APlease%20enter%20your%20name%2C%20email%2C%20designation%2C%20and%20affiliation%20here.%0D%0A%0D%0APlease%20note%3A%20Your%20request%20will%20be%20reviewed%20by%20the%20Steering%20Committee.%20The%20decision%20may%20take%20up%20to%202%20weeks.`;
}
